
import Order from './order.vue'
import Cardorder from './cardorder.vue'
export default {
  Order,
	Cardorder,
}



// WEBPACK FOOTER //
// ./src/views/order/index.js